/**
 * mapAllotmentDepts
 * @param {Object} depts allotment departments with dept number as keys { [departmentNumber]: { ...dept } }
 * @return {Array} list of departments with dept number as property [ { ...dept, departmentNumber } ]
 */
export function mapAllotmentDepts(depts = {}) {
  return Object.entries(depts).map(([departmentNumber, dept]) => ({ ...dept, departmentNumber }));
}

export function mapAllotmentDeptsBillable(depts = {}) {
  return Object.fromEntries(Object.entries(depts).map(([departmentNumber, dept]) => [departmentNumber, dept.billable]));
}

export function mapAndSetAllotmentDeptsBillable(depts = {}, billable) {
  return Object.fromEntries(Object.entries(depts).map(([departmentNumber]) => [departmentNumber, billable]));
}
